var baseTheme = require("../base");
module.exports = /*:: (*/Object.assign({}, baseTheme, {
  brandName: "Vimana",
  bodyClassName: "vimana-theme",
  // Intents
  "bp6-intent-primary": "#1678c2",
  "bp6-app-background-color": "#ffffff",
  "bp6-navbar-height": "48px",
  // App styles follow.
  fontSizeXL: "20px",
  fontSizeXXL: "26px",
  color: "#13161d",
  mutedColor: "#999999",
  linkColor: "#1678c2",
  background: "#ffffff",
  borderColor: "#cfd2d9",
  toolbarBorderColor: "#cfd2d9",
  inverseTextColor: "#e6e9f0",
  ToolbarTextColor: "#635e5e",
  ToolbarBackground: "linear-gradient(to bottom,hsl(204,17%,94%) 0%,hsl(204, 33%, 97%) 79%)",
  SecondaryToolbarTextColor: "#635e5e",
  RightEditPanelBackground: "#fff",
  DefaultTagColor: "$color",
  DefaultTagBackground: "#b4b7be"
}) /*:: :Object)*/;